module.exports = __webpack_public_path__ + "img/q1.48e90a7f.svg";